export const GallerySpacing = 16
